import { FormGroup, InputGroup } from '@blueprintjs/core'
import React, { FC } from 'react'
import Select from 'react-select'
import CX from 'classnames'
import { UprightStyle } from '../../../../../types'
import { renderError } from '../Helpers'

interface Props {
  specificName: string
  value: string
  error: any
  required: boolean
  options: string[]
  onChange: (v: string) => void
  creatable?: boolean
}

const styles: UprightStyle = {
  zeroMarginBottom: { marginBottom: 0 }
}

// TODO(goodwillfinds): virtualize the select component https://app.asana.com/0/1204859485810598/1206817470569563/f
export const SpecificInput: FC<Props> = props => {
  const { required, specificName, value, creatable, options, error } = props
  return (
    <FormGroup
      label={specificName}
      labelInfo={required && 'Required'}
      style={styles.zeroMarginBottom}
      className={CX('float-right-formgroup-label', 'nuke-top-margin-loadable-select')}
      helperText={renderError(error)}
    >
      <Select
        value={value}
        options={options?.map(opt => {
          return {
            value: opt,
            label: opt
          }
        })}
        simpleValue
        creatable={creatable}
        onChange={v => props.onChange(v)}
        placeholder="Select"
        // react-select-same-height-as-blueprint - because often times these specifics will be on the same line
        // as a blueprint InputGroup, like for "Condition Description" or ConditionDescriptorPicker
        className="react-select-same-height-as-blueprint"
      />
    </FormGroup>
  )
}

interface FreeTextInputProps {
  onChange: (v: string) => void
  specificName: string
  value: string
  error?: any
  required?: boolean
}

export const SpecificsFreeTextInput: React.FC<FreeTextInputProps> = props => {
  return (
    <FormGroup
      label={props.specificName}
      labelInfo={props.required && 'Required'}
      style={styles.zeroMarginBottom}
      className={CX('float-right-formgroup-label')}
      helperText={renderError(props.error)}
    >
      <InputGroup value={props.value} onChange={e => props.onChange(e.currentTarget?.value)} />
    </FormGroup>
  )
}
